import types from '../mutation-types';
import Vue from 'vue';
import ContactSessionsAPI from '../../api/contactSessions';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isDeleting: false,
  },
};

export const getters = {
  getSessionsByContactId: _state => contactId => {
    return _state.records[contactId] || [];
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, contactId) {
    commit(types.SET_CONTACT_SESSIONS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactSessionsAPI.getSessions(contactId);
      commit(types.SET_CONTACT_SESSIONS, { contactId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_SESSIONS_UI_FLAG, { isFetching: false });
    }
  },

  async delete({ commit, dispatch }, { contactId, sessionId }) {
    commit(types.SET_CONTACT_SESSIONS_UI_FLAG, { isDeleting: true });
    try {
      await ContactSessionsAPI.deleteSession(contactId, sessionId);
      // Refresh the sessions list after deletion
      dispatch('get', contactId);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_SESSIONS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_SESSIONS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [types.SET_CONTACT_SESSIONS]: ($state, { contactId, data }) => {
    Vue.set($state.records, contactId, data);
  },

  [types.CLEAR_CONTACT_SESSIONS]: ($state, contactId) => {
    Vue.delete($state.records, contactId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 